import type { IntlShape } from 'react-intl';

import {
  createColumn,
  getSortOptions,
} from '../../../../shared/utils/tableUtils';

export const policyTableColumns = [
  createColumn('name', 'Name', '18.75rem', {
    isPinned: true,
  }),
  createColumn('description', 'Description', '18.75rem'),
  createColumn('ruleSummary', 'Rule Summary', '18.75rem'),
  createColumn('status', 'Status', '6rem'),
  {
    key: 'actionColumn',
    label: 'actionColumn',
    value: 'actionColumn',
    isChecked: true,
    isPinned: true,
    isColumnConfigEnabled: true,
    width: '6rem',
  },
];

const sortableColumns = ['name', 'description', 'ruleSummary', 'status'];

export const getSortConfigs = (intl: IntlShape) =>
  sortableColumns.map((key) => ({ key, sortOptions: getSortOptions(intl) }));

export const getKebabMenuList = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      defaultMessage: 'Activate',
      id: 'Ztl4bO',
      description: 'Kebab menu option',
    }),
    value: 'activate',
    icon: 'Activate',
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'De-activate',
      id: '4hsSKW',
      description: 'Kebab menu option',
    }),
    value: 'deActivate',
    icon: 'Reject',
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'Export',
      id: 'PwbNMi',
      description: 'Kebab menu option',
    }),
    value: 'export',
    icon: 'Export',
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'Delete',
      id: 'swop8Z',
      description: 'Kebab menu option',
    }),
    value: 'delete',
    icon: 'Delete',
  },
];
